import { Button } from "@/components/ui/button";
import ConfirmActionDialog from "./ConfirmActionDialog";
import { useConfirmedAction } from "./useConfirmedAction";

interface ResetBaselineActionProps {
  useCaseId: string;
  onResetBaseline: (useCaseId: string) => Promise<unknown>;
}

const ResetBaselineAction = ({ useCaseId, onResetBaseline }: ResetBaselineActionProps) => {
  const action = useConfirmedAction(() => onResetBaseline(useCaseId));
  return (
    <>
      <Button size="sm" variant="outline" onClick={() => action.setOpen(true)}>
        I've reset the baseline
      </Button>
      <ConfirmActionDialog
        open={action.open}
        onOpenChange={action.setOpen}
        title="Baseline is reset?"
        description="Only confirm after you have run npm run eval:set-baseline with the new judge."
        confirmLabel="Yes, baseline is reset"
        pending={action.pending}
        onConfirm={action.confirm}
      />
    </>
  );
};

export default ResetBaselineAction;
